/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelTenderResponseModel } from '../../models/paged-model-tender-response-model';

export interface ListTenders$Params {

/**
 * The merchantId which announced the tender.
 */
  announcerId?: string;

/**
 * The target siteId of tender.
 */
  announcerSiteId?: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function listTenders(http: HttpClient, rootUrl: string, params?: ListTenders$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelTenderResponseModel>> {
  const rb = new RequestBuilder(rootUrl, listTenders.PATH, 'get');
  if (params) {
    rb.query('announcerId', params.announcerId, {});
    rb.query('announcerSiteId', params.announcerSiteId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelTenderResponseModel>;
    })
  );
}

listTenders.PATH = '/tenders';
